export default function (context, value) {
    message(context, {
        id: value,
        title: 'Вы действительно хотите удалить сертификат?',
        data: 'Id=' + value + '&DeleteWithPayments=false',
        cb: data=>{
            if (data.NeedDeletePayments){
                message(context, {
                    id: value,
                    title: 'К сертификату привязаны платежи! Вы действительно хотите удалить сертификат?',
                    data: 'Id=' + value + '&DeleteWithPayments=true',
                    cb: data=>{
                        context.commit('list/remove', value);
                        window.app.$message({
                            type: 'success',
                            message: 'Сертификат удален'
                        });
                    }
                });
                return;
            }
            context.commit('list/remove', value);
            window.app.$message({
                type: 'success',
                message: 'Сертификат удален'
            });
        }
    });
}

function message(context, {title, id, cb, data}) {
    window.app.$confirm(title, 'Удаление сертификат №' + id, {
        confirmButtonText: 'Удалить',
        cancelButtonText: 'Отмена',
        type: 'info'
    }).then(() => {
        axios({
            method: 'post',
            url: '/tourclient/api/giftCertificate/delete',
            data,
            requestId: 'tourclient/api/giftCertificate/delete'
        }).then(({data}) => {
            cb(data);
        }).catch(e => {
            context.dispatch('error', e, {root: true});
        })
    }).catch(e => {
    });
}
